import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import ImageUpload from "../../../layout/ImageUpload/index";
import LivestreamBackground from "../LivestreamBackground";
import cn from "classnames";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";
import {logoIconWhite} from "../../../data/constants";
import {withDeployVersion} from "../../../libs/deployVersion";

// 1280×720 — YouTube / LinkedIn / X livestream card (Figma 4289:2130).
// Existing products use a per-frame SVG. Junie and .NET use a cropped PNG.
// BiggerPicture keeps both product defaults and user uploads editable.
const LivestreamHorizontal = ({id, zoom}) => {
  const {titles, names, names2, names3, positions} = useEdits();
  // `layout-${layoutOption}` on the root scopes per-layout CSS (the speaker
  // photo treatment differs between one-photo layouts 1 & 2; multi-photo
  // layouts 3–7 land later). Mirrors the social channel's layout-class pattern.
  const {layoutOption, titleFontSize} = useSetting();
  const isL3 = Number(layoutOption) === 3;
  const isL4 = Number(layoutOption) === 4;
  const isL5 = Number(layoutOption) === 5;
  const isL6 = Number(layoutOption) === 6;
  const isL7 = Number(layoutOption) === 7;
  const title = titles[id] || titles.main;
  const name = names[id] || names.main;
  const name2 = names2[id] || names2.main;
  const name3 = names3[id] || names3.main;
  const position = positions[id] || positions.main;

  return (
    <div
      id={id}
      className={`template livestream livestream-tpl layout-${layoutOption}`}
      style={{"--zoom-level": zoom}}
    >
      {/* Single export wrapper (libs/export.js clones template.children[0]). */}
      <div className="livestream-tpl__inner">
        <LivestreamBackground id={id} />

        <div className="content">
          <header className="ls-header">JetBrains | Livestream</header>
          <img className="ls-logo" src={withDeployVersion(logoIconWhite)} alt="JetBrains" />

          <h1 className={cn("title", {"title--small": titleFontSize === "small"})}>
            <Textarea id={id} text={title} />
          </h1>

          {/* layouts 5, 6 & 7 show only the photo grid — no speaker names. */}
          {!isL5 && !isL6 && !isL7 && (
          <div className="ls-speaker">
            {isL3 || isL4 ? (
              // Host names on one row. `inline` renders <input size="1"> (not
              // <textarea cols=20>) so each field auto-sizes to its text instead
              // of forcing a ~396px slot that wraps the row. layout-4 adds a
              // third name.
              <>
                <h2 className="name">
                  <Textarea id={id} text={name} inline />
                </h2>
                <span className="ls-sep">, </span>
                <h2 className="name2">
                  <Textarea id={id} text={name2} inline />
                </h2>
                {isL4 && (
                  <>
                    <span className="ls-sep">, </span>
                    <h2 className="name3">
                      <Textarea id={id} text={name3} inline />
                    </h2>
                  </>
                )}
              </>
            ) : (
              <>
                <h2 className="name">
                  <Textarea id={id} text={name} />
                </h2>
                <h2 className="position">
                  <Textarea id={id} text={position} />
                </h2>
              </>
            )}
          </div>
          )}
        </div>

        {isL3 || isL4 || isL5 || isL6 || isL7 ? (
          // Multi-speaker photos (rounded cards). Distinct imageKeys =
          // independent slots shared across templates; template-scoped
          // transformKeys position each (same pattern as the Webinar channel).
          // layout-3 = two, 4 = three, 5 = four (2×2), 6 = five (3+2), 7 = six (3×2).
          <>
            <div className="upload-wrap upload-a">
              <ImageUpload
                id="ls-speaker-1"
                imageKey="ls-speaker-1"
                transformKey={`${id}-ls-speaker-1`}
              />
            </div>
            <div className="upload-wrap upload-b">
              <ImageUpload
                id="ls-speaker-2"
                imageKey="ls-speaker-2"
                transformKey={`${id}-ls-speaker-2`}
              />
            </div>
            {(isL4 || isL5 || isL6 || isL7) && (
              <div className="upload-wrap upload-c">
                <ImageUpload
                  id="ls-speaker-3"
                  imageKey="ls-speaker-3"
                  transformKey={`${id}-ls-speaker-3`}
                />
              </div>
            )}
            {(isL5 || isL6 || isL7) && (
              <div className="upload-wrap upload-d">
                <ImageUpload
                  id="ls-speaker-4"
                  imageKey="ls-speaker-4"
                  transformKey={`${id}-ls-speaker-4`}
                />
              </div>
            )}
            {(isL6 || isL7) && (
              <div className="upload-wrap upload-e">
                <ImageUpload
                  id="ls-speaker-5"
                  imageKey="ls-speaker-5"
                  transformKey={`${id}-ls-speaker-5`}
                />
              </div>
            )}
            {isL7 && (
              <div className="upload-wrap upload-f">
                <ImageUpload
                  id="ls-speaker-6"
                  imageKey="ls-speaker-6"
                  transformKey={`${id}-ls-speaker-6`}
                />
              </div>
            )}
          </>
        ) : (
          <div className="upload-wrap">
            <ImageUpload id={id} />
          </div>
        )}
      </div>
    </div>
  );
};

export default LivestreamHorizontal;
